import React, { useEffect, useMemo, useState } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import { getSchedulerLogs } from '../../../../Redux/sftpClient/action'; // assuming this is correct
import moment from 'moment';
import { Tooltip } from '@mui/material';
import DataTable from 'react-data-table-component';
import queueDatatableCustomStyles from '../../../../Layout/Elements/QueueDatatableCustomStyles';

const SchedulerLogModal = ({ show, onClose, pk }) => {
    const [logData, setLogData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [totalRows, setTotalRows] = useState(0);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(100);
    const [selectedRowId, setSelectedRowId] = useState(null); // better than whole object

    // Fetch function (clean & reusable)
    const fetchLogs = async (pageNum = page, rowsPerPage = perPage) => {
        if (!pk || !show) return;

        setLoading(true);
        try {
            // Make sure your redux action returns a promise or uses callback correctly
            const res = await new Promise((resolve) => {
                getSchedulerLogs({ pk, page: pageNum, perPage: rowsPerPage })(resolve);
            });

            if (res?.status && res?.data) {
                setLogData(res.data.results?.data || res.data.results || []);
                setTotalRows(res.data.count || 0);
            } else {
                setLogData([]);
                setTotalRows(0);
            }
            setLoading(false);
        } catch (err) {
            console.error("Failed to load scheduler logs:", err);
            setLogData([]);
            setTotalRows(0);
        } finally {
            
        }
    };

    // Load data when modal opens or pagination changes
    useEffect(() => {
        if (!pk || !show) return;

        fetchLogs(page, perPage);

    }, [pk, show ,page, perPage]); // ← important: page & perPage must be here

    const handlePageChange = (newPage) => {
        setPage(newPage);
    };

    const handlePerRowsChange = (newPerPage, currentPage) => {
        setPerPage(newPerPage);
        setPage(1); // usually reset to page 1 when changing page size
    };

    const handleRowClicked = (row) => {
        setSelectedRowId(row.id || row.pk); // choose whichever is your unique key
    };

    const handleDownloadSftpLog = (file) => {
        const fileURL = file;

        let alink = document.createElement('a');
        alink.href = fileURL;
        alink.download = 'SamplePDF.pdf';
        alink.target = '_blank';
        alink.click();
    };

    const conditionalRowStyles = [
        {
            when: (row) => row.id === selectedRowId || row.pk === selectedRowId,
            style: {
                backgroundColor: '#dbf4f5',
                // border: '1px solid #00acc1',
                // fontWeight: 'bold',
            },
        },
        {
            when: (row, index) => index % 2 === 0,
            style: {
                backgroundColor: '#f8f9fa', // light gray for even rows (optional)
            },
        },
    ];

    const columns = useMemo(
            () => [
                {
                    id: 'id',
                    name: 'S NO',
                    selector: (row, index) => page == 1 ? index + 1 : (page - 1) * perPage + index + 1,
                    cell:(row,index) =>
                    <div>
                       { page == 1 ? index + 1 : (page - 1) * perPage + index + 1}
                       {row?.is_error_occured && <i class=" ms-2 blink blinking-text bi bi-exclamation-circle"></i>} 
                    </div>,
                    wrap: true,
                    width: "50px",
                    grow: 0,
    
    
                   
                },
                {
                    name: "Date",
                    selector: (row) => row.created_date, sortable: true,
                    width: "120px",
                    style: {
                        fontSize: "10px  "
                    },
                },
                {
                    name: "CreatedBy",
                    selector: (row) => row.user_name, sortable: true,
                      cell: (row) =>
                        <div className='text-truncate ' style={{ width: "120px", overflow: 'hidden' }} >
                            <Tooltip disableInteractive title={row?.user_name} placement='top' arrow >
                                <span className='text-truncate ' >
                                    {row?.user_name}
                                </span>
                            </Tooltip>
                        </div>
                    ,
                    width: "120px",
                     style: {
                        fontSize: "10px  "
                    },
                },
                {
                    name: "Status",
                    selector: (row) => row.status, sortable: true,
                    width: "120px",
                     style: {
                        fontSize: "10px  "
                    },
                },
                {
                    id: 'comment',
                    name: 'Comment',
                    selector: row => row?.comment,
                    cell: (row) =>
                        <div className='text-truncate ' style={{ width: "700px", overflow: 'hidden' }} >
                            <Tooltip disableInteractive title={row?.comment} placement='top' arrow >
                                <span className='text-truncate ' >
                                    {row?.comment}
                                </span>
                            </Tooltip>
                        </div>
                    ,
                    sortable: true,
                    wrap: true,
                    grow: 3,
                    minWidth: "550px",
                    cell: (row) => (
                        <Tooltip title={row.comment || ''} placement="top" arrow>
                            <div className="text-truncate" style={{ maxWidth: '100%' }}>
                                {row.comment || '-'}
                            </div>
                        </Tooltip>
                    ),
                },
                {
                    name: "Action",
                    width: "80px",
                    center: true,
                    cell: (row) => (
                        row?.log_record &&
                        <Tooltip title={row?.log_record ? "Download Log" : "No Log Available"} placement="top" arrow>
                            <div style={{ cursor: !row?.log_record ? 'not-allowed' : 'pointer', display: 'inline-block' }}>
                                <button 
                                    className='btn btn-sm border-0 p-0' 
                                    onClick={() => handleDownloadSftpLog(row?.log_record)}
                                    style={{ 
                                        fontSize: '0.75rem', 
                                        color: row?.log_record ? '#6ba2b6' : '#ccc',
                                        pointerEvents: !row?.log_record ? 'none' : 'auto'
                                    }}
                                >
                                    <i className="bi bi-download fs-6" ></i>
                                </button>
                            </div>
                        </Tooltip>
                    ),
                },
            ],
            [page,perPage]
        );

    return (
        <Modal
            show={show}
            onHide={()=>{onClose();setLogData([]);setPage(1);setPerPage(100)}}
            size="xl"
            centered
            dialogClassName="custom-modal-width"
        >
            <Modal.Header closeButton>
                <Modal.Title className="d-flex align-items-center justify-content-between ">
                    <span className=' mx-3 ' > Scheduler Logs</span>
                     <Tooltip title="Refresh" placement='top' arrow>
                    <Button className="btn btn-light btn-active-primary " 
                        
                        onClick={() => fetchLogs(page, perPage)}
                        disabled={loading}
                    >
                        {loading ? (
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            />
                        ) : (
                            <i className="bi-arrow-clockwise me-1"></i>
                        )}
                        
                    </Button>
                    </Tooltip>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body style={{ height: '80vh', overflowY: 'auto', padding: '1rem' }}>
               
                    <DataTable
                        className="custom-datatable w-100 p-0"
                        fixedHeader
                        columns={columns}
                        data={logData}
                        pagination
                        paginationServer
                        paginationTotalRows={totalRows}
                        paginationPerPage={perPage}
                        paginationDefaultPage={page}
                        paginationRowsPerPageOptions={[5,10, 25, 50, 100]}
                        onChangePage={handlePageChange}
                        onChangeRowsPerPage={handlePerRowsChange}
                        pointerOnHover
                        onRowClicked={handleRowClicked}
                        highlightOnHover
                        responsive
                        customStyles={queueDatatableCustomStyles}
                        conditionalRowStyles={conditionalRowStyles}
                         progressPending={loading}
                         progressComponent={<Spinner animation="border" />} //
                        
                    />
                
            </Modal.Body>
        </Modal>
    );
};

export default SchedulerLogModal;
